// What is Site Code: https://support.wix.com/en/article/corvid-working-in-the-code-panel

$w.onReady(function () {
	// Write your code here
});

/**
*	Adds an event handler that runs when an element is displayed
 in the viewable part of the current window.
*	 @param {$w.Event} event
*/
export function footer1_viewportEnter(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

/**
*	Adds an event handler that runs when an element is no longer
 displayed in the viewable part of the current window.
*	 @param {$w.Event} event
*/
export function footer1_viewportLeave(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}